var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Test"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Test"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M18.5669 20.541C18.5669 20.8822 18.4314 21.2094 18.1901 21.4507C17.9488 21.692 17.6216 21.8275 17.2804 21.8275H3.12835C2.78713 21.8275 2.45989 21.692 2.21862 21.4507C1.97734 21.2094 1.8418 20.8822 1.8418 20.541V3.81585C1.8418 3.47463 1.97734 3.14739 2.21862 2.90612C2.45989 2.66484 2.78713 2.5293 3.12835 2.5293H12.2448C12.5858 2.52937 12.9128 2.6648 13.154 2.90583L18.1904 7.94224C18.4314 8.18342 18.5669 8.51043 18.5669 8.8514V20.541Z",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reload",
    d: "M10.3232 18.6506C11.8357 18.6506 13.1348 18.1077 14.2207 17.0218C15.3066 15.9359 15.8495 14.6368 15.8495 13.1243C15.8495 11.6118 15.3066 10.3127 14.2207 9.2268C13.1348 8.14092 11.8357 7.59799 10.3232 7.59799C9.58635 7.59799 8.89798 7.73372 8.25809 8.00519C7.61821 8.27666 7.04618 8.64508 6.54203 9.11045V7.30713H4.79688V12.2517H9.74147V10.5066H7.64729C7.97693 10.1575 8.37444 9.87638 8.83981 9.66308C9.30519 9.44979 9.79964 9.34314 10.3232 9.34314C11.3703 9.34314 12.2622 9.71156 12.9991 10.4484C13.7359 11.1852 14.1044 12.0772 14.1044 13.1243C14.1044 14.1714 13.7359 15.0634 12.9991 15.8002C12.2622 16.537 11.3703 16.9055 10.3232 16.9055C9.47001 16.9055 8.72347 16.6584 8.08358 16.1644C7.44369 15.6695 6.98801 15.044 6.71654 14.2877H4.91322C5.18469 15.5481 5.81992 16.5906 6.81892 17.4151C7.81715 18.2388 8.98524 18.6506 10.3232 18.6506Z",
    fill: "#767676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshReport);
export default __webpack_public_path__ + "static/media/refreshReport.a17b6caf7987f180866bc29a2592a114.svg";
export { ForwardRef as ReactComponent };